var render = function render(){var _vm=this,_c=_vm._self._c;return _c('donut-chart08-template',{attrs:{"board-ids":[160],"data-type":_vm.dataType,"field-code":"facility-public","graph-id":85,"title":"(공중(다중)이용시설) 유해·위험요인 점검(개선) 현황","unit":"건"}})
}
var staticRenderFns = []

export { render, staticRenderFns }